import { preProcedureSedativesById } from '../pre-procedure-drugs'
import { createSelector } from '../utils/selector-utils'
import { selectPreProcedureSedativeDosesAdministered } from './drugs-administered'
import { selectCaseOralSedatives } from './oral-sedative'
import { selectCaseParenDrugs } from './paren-drug'

/** @type {CaseSelector<PreProcedureSedativeDoseWithDrug[]>} */
export const selectPreProcedureSedativeDosesAdministeredWithDrug = createSelector(
  selectCaseParenDrugs,
  selectCaseOralSedatives,
  selectPreProcedureSedativeDosesAdministered,
  (caseParenDrugs, caseOralSedatives, preProcedureSedativeDoses) => {
    const result = []
    for (const dose of preProcedureSedativeDoses) {
      const { drugId, route } = dose
      let drug
      if (route === 'PO' || route === 'SL') {
        drug = caseOralSedatives[drugId]
      } else {
        drug = caseParenDrugs[drugId]
      }
      /**
       * Noted Feb, 24, 2025: We do this as a fallback for older cases that
       * could potentially not have the drug in the case data. We likely don't
       * need to keep this here indefinitely.
       */
      if (!drug) {
        const matchedDrug = preProcedureSedativesById[drugId]
        if (matchedDrug) {
          drug = { name: matchedDrug.name, unit: matchedDrug.unit }
        }
      }
      if (drug) {
        result.push({ ...dose, drug })
      }
    }
    return result
  }
)
